import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block text-xs font-semibold text-neutral-600 mb-3" }
const _hoisted_2 = { class: "flex flex-col space-y-2" }
const _hoisted_3 = { class: "flex space-x-6" }
const _hoisted_4 = { class: "w-1/2" }
const _hoisted_5 = { class: "w-1/2" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_7 = { class: "min-w-full divide-y border-none divide-gray-200" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3 text-center text-xs text-gray-500 font-semibold whitespace-nowrap" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Order")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3 text-left text-xs text-gray-500 font-semibold whitespace-nowrap" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Option Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3 text-left text-xs text-gray-500 font-semibold whitespace-nowrap" })
  ])
], -1)
const _hoisted_9 = { class: "p-2 ss" }
const _hoisted_10 = { class: "p-2 w-full" }
const _hoisted_11 = { class: "p-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { colspan: "3" }
const _hoisted_14 = { class: "flex text-sm justify-end items-center mt-3" }

import { ref } from "vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ContentModal from "../ContentModal.vue";
import { PlusIcon, TrashIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataRadio',
  props: {
	form: {
		type: Object,
	},
    value: {
        default: null,
        required: true,
    },
    label: {
        type: String,
        default: 'Data is coming from?',
    },
    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;
const form = ref<object>(props.form);
const showExistingModal = ref<boolean>(true);
const target = ref<string>('');
const fieldOptions = ref<string[]>([]);

const data_options = [
    { id: '1', label: 'Existing', value: 'existing', radioSelected: null},
    { id: '2', label: 'Manual', value: 'manual', radioSelected: null},
]

const changeMeOptions = [
    { id: '1', label: 'Change', value: 'Change'},
    { id: '2', label: 'Me', value: 'Me'},
]

const addOptions = () => {
    fieldOptions.value.push(`Container ${fieldOptions.value.length + 1}`);
};

const deleteOptions = (index: number) => {
    fieldOptions.value.splice(index, 1);
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RadioGroup, {
        options: data_options,
        name: "data",
        modelValue: target.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((target).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(ContentModal, { show: showExistingModal.value }, {
      button: _withCtx(() => [
        _createVNode(ButtonComponent, {
          btnWidth: "quinary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showExistingModal.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cancel ")
          ]),
          _: 1
        }),
        _createVNode(ButtonComponent, { customClass: "primary" }, {
          default: _withCtx(() => [
            _createTextVNode(" Submit ")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(MultiSelect, {
              options: changeMeOptions,
              label: "Module",
              id: "module",
              name: "module",
              placeholder: "Select..",
              searchable: ""
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(MultiSelect, {
              options: changeMeOptions,
              label: "Fields (w/ options only)",
              id: "fields",
              name: "fields",
              placeholder: "Select..",
              searchable: ""
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (target.value == 'manual')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldOptions.value, (container, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_9, [
                    _createVNode(TextInput, {
                      type: "number",
                      id: 'sort_' + index,
                      name: 'sort_' + index,
                      customClass: "intervention-sortorder border text-center w-9 h-9 rounded text-xs text-neutral-600 border-neutral-100 bg-transparent focus:border-neutral-900 focus:outline-none focus:ring-0"
                    }, null, 8, ["id", "name"])
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _createVNode(TextInput, {
                      type: "number",
                      id: 'input_' + index,
                      name: 'input_' + index,
                      placeholder: "Type options name",
                      customClass: "h-9 !pr-2 !pl-2 text-xs"
                    }, null, 8, ["id", "name"])
                  ]),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "flex text-sm items-center text-red-500 hover:text-red-700 active:text-red-300 transition",
                      onClick: ($event: any) => (deleteOptions(index))
                    }, [
                      _createVNode(_unref(TrashIcon), {
                        class: "h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ], 8, _hoisted_12)
                  ])
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", {
                      class: "flex text-primary-500 hover:text-primary-700 active:text-primary-300 font-medium transition italic cursor-pointer",
                      onClick: addOptions
                    }, [
                      _createVNode(_unref(PlusIcon), {
                        class: "-ml-0.5 mr-2 h-5 w-5",
                        "aria-hidden": "true"
                      }),
                      _createTextVNode(" Add Another Option ")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})